if (!customElements.get('gk-video-review-cards')) {
  customElements.define('gk-video-review-cards', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.gkv-cards__track');
      this.progress = this.querySelector('.gkv-cards__progress');
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('.gkv-cards__player');
      this.cards = [...this.querySelectorAll('[data-gkv-source]')];
      this.cards.forEach(card => card.addEventListener('click', () => {
        this.player.src = card.dataset.gkvSource;
        this.dialog.showModal();
        this.player.play().catch(() => {});
      }, options));
      this.querySelector('.gkv-cards__close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.player.pause();
        this.player.removeAttribute('src');
        this.player.load();
      }, options);
      this.track.addEventListener('scroll', () => this.updateProgress(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const increment = (this.cards[0]?.getBoundingClientRect().width || 140) + 8;
        const left = event.key === 'Home' ? 0 : event.key === 'End' ? this.track.scrollWidth : this.track.scrollLeft + increment * (event.key === 'ArrowLeft' ? -1 : 1);
        this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.updateProgress());
      this.resizeObserver.observe(this.track);
      const loadThumbnail = video => {
        if (video.getAttribute('src')) return;
        video.addEventListener('loadedmetadata', () => {
          const time = Number.isFinite(video.duration) ? Math.min(.5, video.duration / 2) : .1;
          if (time > 0) video.currentTime = time;
          else video.setAttribute('data-ready', '');
        }, { ...options, once: true });
        video.addEventListener('seeked', () => video.setAttribute('data-ready', ''), { ...options, once: true });
        video.muted = true;
        video.preload = 'metadata';
        video.src = video.dataset.src;
      };
      this.thumbnailObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        this.querySelectorAll('[data-gkv-thumbnail]').forEach(loadThumbnail);
        this.thumbnailObserver.disconnect();
      }), { rootMargin: '400px' });
      this.thumbnailObserver.observe(this);
      this.updateProgress();
    }
    updateProgress() {
      const total = this.track.scrollWidth;
      const visible = this.track.clientWidth;
      this.progress.hidden = total <= visible + 1;
      const indicator = this.progress.firstElementChild;
      indicator.style.width = `${Math.min(100, visible / Math.max(total, 1) * 100)}%`;
      indicator.style.transform = `translateX(${Math.max(0, this.track.scrollLeft) / Math.max(visible, 1) * 100}%)`;
    }
    disconnectedCallback() {
      this.player?.pause();
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      this.thumbnailObserver?.disconnect();
    }
  });
}
